import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RentalsService } from '../../../../../../../services/rentals.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment'
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rental-reservation-long-term-payment-schedule',
  templateUrl: './rental-reservation-long-term-payment-schedule.component.html',
  styleUrls: ['./rental-reservation-long-term-payment-schedule.component.scss'],
})
export class RentalReservationLongTermPaymentScheduleComponent
  implements OnInit
{
  @Input() partner;
  @Input() countryData;
  @Input() reservation;
  @Input() reloadPaymentSchedule;
  @Output() reloadReservation = new EventEmitter();
  @Output() clearReloadPaymentScheduleFlag = new EventEmitter();

  public largestDate: Date | null = null;
  public largestDateIndex: number | null = null;
  public showAddButton: boolean = true;
  public selectedStatusID: any;
  public today: Date = new Date();
  public busy: boolean = false;
  public retryingPayment: boolean = false;
  public longTermPaymentSchedule: any = [];
  public longTermPaymentScheduleStatueses: any = [
    {
      status: 0,
      label: 'bikeshop.rentals.long_term_payment_statuses.scheduled',
    },
    { 
      status: 1, 
      label: 'bikeshop.rentals.long_term_payment_statuses.paid' 
    },
    {
      status: 2,
      label: 'bikeshop.rentals.long_term_payment_statuses.payment_failed',
    },
    {
      status: 100,
      label: 'bikeshop.rentals.long_term_payment_statuses.cancelled',
    },
  ];

  public longTermPaymentScheduleStatuesesForDropdown: any[];

  constructor(
    private rentalsService: RentalsService,
    private modalService: NgbModal,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit() {    
    this.translateLongTermPaymentScheduleStatuesesForDropdown();
    this.getLongTermPaymentSchedule();
  }

  ngOnChanges(changes: any): void {
    if(changes.reloadPaymentSchedule){
      this.getLongTermPaymentSchedule();
      this.clearReloadPaymentScheduleFlag.emit();
    }
  }

  translateLongTermPaymentScheduleStatuesesForDropdown(){
    this.longTermPaymentScheduleStatueses.forEach(item => {
      item.label = this.translate.instant(item.label);
    });
  }

  getLongTermPaymentSchedule() {
    this.rentalsService
      .getRentalReservationLongTermPaymentSchedule(
        this.partner.ID,
        this.reservation.id,
      )
      .subscribe((longTermPaymentSchedule) => {
        // Modify each object in the array to add the edit parameter
        this.longTermPaymentSchedule = longTermPaymentSchedule.map(item => {
          return { 
            ...item, 
            edit: false,
            scheduleDate: moment(item.scheduleDate).toDate()
          };
        });

        console.log(this.longTermPaymentSchedule);
        
        this.retryingPayment = false;
      });
  }

  getStatus(statusID) {
    return this.longTermPaymentScheduleStatueses
      .filter((x) => {
        return x.status === statusID;
      })
      .pop().label;
  }

  retryProcessRentalsRecuringPayment(paymentScheduleID) {
    this.retryingPayment = true;
    this.rentalsService
      .retryProcessRentalsRecuringPayment(this.partner.ID, paymentScheduleID)
      .subscribe(
        (longTermPaymentSchedule) => {
          this.getLongTermPaymentSchedule();
          setTimeout(() => {
            this.reloadReservation.emit({});
          }, 5000);
        },
        (err) => {
          this.getLongTermPaymentSchedule();
        },
      );
  }

  onStatusChange(event, paymentSchedule){
    console.log(event);
    console.log(paymentSchedule);

    this.selectedStatusID = event.value;

    // Find the index of the clicked payment item in the array
    const index = this.longTermPaymentSchedule.indexOf(paymentSchedule);
    if (index !== -1) {
      this.longTermPaymentSchedule[index].statusID = event.value.status;
      console.log(this.longTermPaymentSchedule[index]);
    }
  }

  editScheduleItem(paymentSchedule){
    // Find the index of the clicked payment item in the array
    const index = this.longTermPaymentSchedule.indexOf(paymentSchedule);
  
    // Update the 'edit' status of the clicked item to true
    if (index !== -1) {
      this.longTermPaymentScheduleStatuesesForDropdown = this.longTermPaymentScheduleStatueses.filter(item => [0, 1, 100].includes(item.status));

      this.selectedStatusID = this.longTermPaymentScheduleStatueses.find(item => item.status === this.longTermPaymentSchedule[index].statusID);
      console.log(this.longTermPaymentScheduleStatueses.find(item => item.status === this.longTermPaymentSchedule[index].statusID));
      this.longTermPaymentSchedule[index].edit = true;
    }
  }

  addScheduleItem(){
    // Check if any item in the existing list has ID 0
    const hasAddItemPending = this.longTermPaymentSchedule.some(item => item.id === 0);
    if(hasAddItemPending){
      return;
    }

    this.longTermPaymentScheduleStatuesesForDropdown = this.longTermPaymentScheduleStatueses.filter(item => [0, 1].includes(item.status));

    this.showAddButton = false;

    let scheduledDate = null;
    let total = 0;

    if(this.longTermPaymentSchedule.length > 0)
    {
      this.getLastScheduledDate();
      if(this.largestDateIndex != null)
      {
        const momentDate = moment(this.longTermPaymentSchedule[this.largestDateIndex].scheduleDate);
        const newDate = momentDate.add(1, 'months');

        scheduledDate = newDate.toDate();
        total = this.longTermPaymentSchedule[this.largestDateIndex].total;
      }
    }    

    this.longTermPaymentSchedule.push({
      "id": 0, 
      "rentalPaymentID": 0,
      "scheduleDate": scheduledDate == null ? "" : scheduledDate,
      "statusID": 0,
      "externalStatusID": 0,
      "externalKey": null,
      "lastSyncDate": null,
      "subTotal": 0, 
      "discount": 0,
      "tax": 0, 
      "total": total, 
      "paymentDate": null,
      "stripePaymentIntentId": null,
      "paymentFailures": null,
      "edit": true
    });
  }

  saveNewScheduleItem(index, paymentSchedule){
    const data = {
      ReservationID: this.reservation.id,
      StatusID: paymentSchedule.statusID.status,
      ScheduleDate: paymentSchedule.scheduleDate,
      Total: paymentSchedule.total
    };

    this.rentalsService.addPaymentSchedule(data).subscribe(
      (addedSchedule) => {
        console.log(addedSchedule);
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.booking.long_term_payment.added_success',
          ),
        });

        this.longTermPaymentSchedule[index].edit = false;
        this.longTermPaymentSchedule[index].id = addedSchedule.id;

        this.showAddButton = true;
      },
      (error) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.booking.long_term_payment.added_error',
          ),
        });
      },
    );
  }

  updateScheduleItem(index, paymentSchedule){
    this.rentalsService.updatePaymentSchedule(paymentSchedule).subscribe(
      (updatedSchedule) => {

        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.booking.long_term_payment.updated_success',
          ),
        });

        this.longTermPaymentSchedule[index].edit = false;
      },
      (error) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.booking.long_term_payment.updated_error',
          ),
        });
      },
    );
  }

  setScheduleItem(paymentSchedule){
    // Find the index of the clicked payment item in the array
    const index = this.longTermPaymentSchedule.indexOf(paymentSchedule);

    if (index !== -1) {
      this.busy = true;

      if(this.longTermPaymentSchedule[index].id == 0)
      {
        this.saveNewScheduleItem(index, paymentSchedule);
      }
      else{
        this.updateScheduleItem(index, paymentSchedule);
      }
    }
  }

  cancelScheduleItem(paymentSchedule){
    // Find the index of the clicked payment item in the array
    const index = this.longTermPaymentSchedule.indexOf(paymentSchedule);

    if (index !== -1) 
    {
      if(this.longTermPaymentSchedule[index].id == 0)
      {
        //Remove
        this.longTermPaymentSchedule.splice(index, 1);
      }
      else{
        this.longTermPaymentSchedule[index].edit = false;
      }      
    }
  }

  getLastScheduledDate(){
    this.longTermPaymentSchedule.forEach((item, index) => {
      if (!this.largestDate || item.scheduledDate > this.largestDate) {
        this.largestDate = item.scheduledDate;
        this.largestDateIndex = index;
      }
    });
  }
}
